webpackJsonp([114276838955818,60335399758886],{

/***/ 104:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(175);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(104);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/GarageGothic-Bold.9c32cc85.otf";

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/TFP-logo-header-black.8a56e28c.png";

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/TFP-logo-header-white.fb6ae1ae.png";

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/underline-grey.33f1ffb6.png";

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GarageGothicBold = __webpack_require__(211);
	
	var _GarageGothicBold2 = _interopRequireDefault(_GarageGothicBold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fontString = '\n@font-face {\n  font-family: GarageGothic;\n  font-weight: 600;\n  src: url(' + _GarageGothicBold2.default + ') format(\'opentype\');\n}\n';
	
	exports.default = function () {
	  return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: fontString } });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _newsletter = __webpack_require__(77);
	
	var _newsletter2 = _interopRequireDefault(_newsletter);
	
	__webpack_require__(355);
	
	var _TFPLogoHeaderWhite = __webpack_require__(155);
	
	var _TFPLogoHeaderWhite2 = _interopRequireDefault(_TFPLogoHeaderWhite);
	
	var _TFPLogoWhite = __webpack_require__(406);
	
	var _TFPLogoWhite2 = _interopRequireDefault(_TFPLogoWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	    _inherits(Footer, _React$Component);
	
	    function Footer(props) {
	        _classCallCheck(this, Footer);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    Footer.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'footer',
	                { className: 'footer' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer__inner' },
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/' },
	                        _react2.default.createElement('img', { className: 'footer__logo', src: _TFPLogoHeaderWhite2.default }),
	                        _react2.default.createElement('img', { className: 'footer__logo mobile', src: _TFPLogoWhite2.default })
	                    ),
	                    _react2.default.createElement(_newsletter2.default, null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'footer__links-container' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'footer__link', to: '/about' },
	                                'About Us'
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'footer__link', href: 'mailto:hello@thefarmproject.com', target: '_blank' },
	                                'Contact'
	                            ),
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'footer__link', to: '/careers' },
	                                'Careers'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'footer__link', to: '/blog' },
	                                'Blog'
	                            ),
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { className: 'footer__link', to: '/collaborations' },
	                                'Collaborations'
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'footer__link', href: 'https://www.lettucegrow.com/', target: '_blank' },
	                                'Lettuce Grow',
	                                _react2.default.createElement('i', { className: 'fas fa-external-link-alt' })
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                {
	                                    className: 'footer__link',
	                                    href: 'https://www.facebook.com/yourfoodsrootsbyattn/',
	                                    target: '_blank'
	                                },
	                                'Your Food\'s Roots',
	                                _react2.default.createElement('i', { className: 'fas fa-external-link-alt' })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'footer__social' },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'social-icon', href: 'https://instagram.com/farmproject', target: '_blank' },
	                            _react2.default.createElement('i', { className: 'fab fa-instagram' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'social-icon', href: 'https://www.facebook.com/thefarmproject', target: '_blank' },
	                            _react2.default.createElement('i', { className: 'fab fa-facebook' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'footer__copyright' },
	                        'Copyright \xA9 2018, The Farm Project.',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/terms' },
	                            'Terms of Use'
	                        ),
	                        ' | ',
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/privacy' },
	                            'Privacy Policy'
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Footer;
	}(_react2.default.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(356);
	
	__webpack_require__(358);
	
	var _TFPLogoHeaderBlack = __webpack_require__(405);
	
	var _TFPLogoHeaderBlack2 = _interopRequireDefault(_TFPLogoHeaderBlack);
	
	var _TFPLogoHeaderWhite = __webpack_require__(155);
	
	var _TFPLogoHeaderWhite2 = _interopRequireDefault(_TFPLogoHeaderWhite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	    _inherits(Header, _React$Component);
	
	    function Header(props) {
	        _classCallCheck(this, Header);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = { menuOpen: false };
	        _this.closeDropdown = _this.closeDropdown.bind(_this);
	        _this.toggleDropdown = _this.toggleDropdown.bind(_this);
	        return _this;
	    }
	
	    Header.prototype.closeDropdown = function closeDropdown() {
	        this.setState({ menuOpen: false });
	    };
	
	    Header.prototype.toggleDropdown = function toggleDropdown() {
	        this.setState({ menuOpen: !this.state.menuOpen });
	    };
	
	    Header.prototype.render = function render() {
	        var location = this.props.location;
	        var inBlogSection = location && location.pathname.indexOf('/blog') === 0;
	        var inBlogArticle = inBlogSection && location.pathname.length > 5;
	        var inCollaborationsSection = location && location.pathname.indexOf('/collaborations') === 0;
	        var inTerms = location && location.pathname.indexOf('/terms') === 0;
	        var inPrivacy = location && location.pathname.indexOf('/privacy') === 0;
	        var blackHeader = inCollaborationsSection || inTerms || inPrivacy;
	
	        return _react2.default.createElement(
	            'div',
	            {
	                className: 'header\n          ' + (blackHeader ? 'header__black' : '') + '\n          ' + (this.state.menuOpen ? 'header__mobile-menu-open' : '') + '\n        '
	            },
	            _react2.default.createElement(
	                'h3',
	                null,
	                'The Farm Project'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'header__links-container' },
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { activeClassName: 'active', to: '/about' },
	                    'About Us'
	                ),
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { activeClassName: 'active', to: '/collaborations' },
	                    'Collaborations'
	                ),
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { activeClassName: 'active', to: '/blog' },
	                    'Blog'
	                ),
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { activeClassName: 'active', to: '/careers' },
	                    'Careers'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.lettucegrow.com/', target: '_blank', rel: 'noopener noreferrer' },
	                    'Lettuce Grow',
	                    _react2.default.createElement('i', { className: 'fas fa-external-link-alt' })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'mobile' },
	                _react2.default.createElement('input', { id: 'mobile-nav', type: 'checkbox', checked: this.state.menuOpen ? 'checked' : '' }),
	                _react2.default.createElement(
	                    'label',
	                    { onClick: this.toggleDropdown },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        _react2.default.createElement('i', null),
	                        _react2.default.createElement('i', null),
	                        _react2.default.createElement('i', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'menu',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/about', onClick: this.toggleDropdown },
	                            'About Us'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/collaborations', onClick: this.toggleDropdown },
	                            'Collaborations'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/blog', onClick: this.toggleDropdown },
	                            'Blog'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/careers', onClick: this.toggleDropdown },
	                            'Careers'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://www.lettucegrow.com/', target: '_blank', rel: 'noopener noreferrer' },
	                            'Lettuce Grow',
	                            _react2.default.createElement('i', { className: 'fas fa-external-link-alt' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mobile-social' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'FOLLOW US'
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'social-icon', href: 'https://instagram.com/farmproject', target: '_blank' },
	                            _react2.default.createElement('span', { className: 'fab fa-instagram' })
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'social-icon', href: 'https://www.facebook.com/thefarmproject', target: '_blank' },
	                            _react2.default.createElement('span', { className: 'fab fa-facebook' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: inBlogArticle ? '/blog' : '/', onClick: this.closeDropdown },
	                _react2.default.createElement('img', { className: 'header__logo header__logo__black', src: _TFPLogoHeaderBlack2.default }),
	                _react2.default.createElement('img', { className: 'header__logo header__logo__white', src: _TFPLogoHeaderWhite2.default })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'header__social' },
	                _react2.default.createElement(
	                    'a',
	                    { className: 'social-icon', href: 'https://instagram.com/farmproject', target: '_blank' },
	                    _react2.default.createElement('i', { className: 'fab fa-instagram' })
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { className: 'social-icon', href: 'https://www.facebook.com/thefarmproject', target: '_blank' },
	                    _react2.default.createElement('i', { className: 'fab fa-facebook' })
	                )
	            )
	        );
	    };
	
	    return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsletterSubmitMessage = function NewsletterSubmitMessage(props) {
	  var visibleClass = props.isVisible ? 'newsletter__feedback--visible' : '';
	  var submittedClass = props.submitted ? 'newsletter__feedback--submitted' : '';
	  return _react2.default.createElement(
	    'div',
	    { className: 'newsletter__feedback ' + visibleClass + ' ' + submittedClass },
	    props.message
	  );
	};
	
	exports.default = NewsletterSubmitMessage;
	module.exports = exports['default'];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _underlineGrey = __webpack_require__(118);
	
	var _underlineGrey2 = _interopRequireDefault(_underlineGrey);
	
	var _newsletterSubmitMessage = __webpack_require__(76);
	
	var _newsletterSubmitMessage2 = _interopRequireDefault(_newsletterSubmitMessage);
	
	__webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var encode = function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	};
	
	var Newsletter = function (_React$Component) {
	  _inherits(Newsletter, _React$Component);
	
	  function Newsletter(props) {
	    _classCallCheck(this, Newsletter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	      if (!re.test(_this.state.email)) {
	        _this.setState({
	          submitResponse: 'Hm, that doesn’t look like a valid e-mail address.',
	          submitResponseIsVisible: true
	        });
	        return;
	      }
	
	      fetch('/', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode({ 'form-name': 'newsletter', email: _this.state.email })
	      }).then(function () {
	        _this.setState({
	          submitted: true,
	          submitResponse: 'Thanks for signing up! We’ll be in touch.',
	          submitResponseIsVisible: true
	        });
	        window.ga('send', {
	          hitType: 'event',
	          eventCategory: 'Newsletter',
	          eventAction: 'Sign Up',
	          eventLabel: _this.props.home ? 'Home' : 'Footer'
	        });
	      }).catch(function (error) {
	        _this.setState({
	          submitResponse: 'Oops... Something went wrong.',
	          submitResponseIsVisible: true
	        });
	      });
	    };
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      return _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    };
	
	    _this.state = {
	      email: '',
	      submitted: false,
	      submitResponse: '',
	      submitResponseIsVisible: false
	    };
	
	    _this.resetSubmitMessage = _this.resetSubmitMessage.bind(_this);
	    return _this;
	  }
	
	  /* Here’s the juicy bit for posting the form submission */
	
	
	  Newsletter.prototype.resetSubmitMessage = function resetSubmitMessage() {
	    this.setState({
	      submitResponseIsVisible: false
	    });
	  };
	
	  Newsletter.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'newsletter' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'newsletter__title' },
	        'Sign up for our newsletter',
	        _react2.default.createElement(
	          'span',
	          null,
	          '!'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'newsletter__cta' },
	        'Stay up to date with the latest news from The Farm Project.',
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'span',
	          { className: 'newsletter__privacy' },
	          '(Your data is safe. We\u2019d never share it with any third parties.)'
	        )
	      ),
	      _react2.default.createElement(
	        'form',
	        {
	          name: 'newsletter',
	          'data-netlify': 'true',
	          onSubmit: this.handleSubmit,
	          className: 'newsletter__form ' + (this.state.submitted ? 'newsletter__form__submitted' : '')
	        },
	        _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'newsletter' }),
	        _react2.default.createElement('input', {
	          type: 'email',
	          className: 'newsletter__field',
	          placeholder: 'Email address',
	          name: 'email',
	          onChange: this.handleChange,
	          onFocus: this.resetSubmitMessage
	        }),
	        _react2.default.createElement('input', { type: 'submit', className: 'newsletter__button', value: 'Join Us' })
	      ),
	      _react2.default.createElement(_newsletterSubmitMessage2.default, {
	        submitted: this.state.submitted,
	        message: this.state.submitResponse,
	        isVisible: this.state.submitResponseIsVisible
	      })
	    );
	  };
	
	  return Newsletter;
	}(_react2.default.Component);
	
	exports.default = Newsletter;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(145);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _fontLoader = __webpack_require__(171);
	
	var _fontLoader2 = _interopRequireDefault(_fontLoader);
	
	var _header = __webpack_require__(173);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(172);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(363);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meta = function Meta() {
	    return _react2.default.createElement(_reactHelmet2.default, {
	        title: 'The Farm Project \u2013 by Zooey Deschanel & Jacob Pechenik',
	        meta: [{
	            name: 'description',
	            content: 'The Farm Project was founded by Zooey Deschanel and Jacob Pechenik with the mission to reconnect people with food.'
	        }, {
	            name: 'keywords',
	            content: 'organic, food, farm, local, community, people'
	        }, {
	            name: 'title',
	            content: 'The Farm Project – by Zooey Deschanel & Jacob Pechenik'
	        }]
	    });
	};
	
	var IndexLayout = function IndexLayout(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(Meta, null),
	        _react2.default.createElement(_fontLoader2.default, null),
	        _react2.default.createElement(_header2.default, { key: props.location.pathname, location: { pathname: props.location.pathname } }),
	        props.children(),
	        _react2.default.createElement(_footer2.default, null)
	    );
	};
	
	exports.default = IndexLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-f3d3aaf33167675d99b2.js